<template>
  <div class="spl-linehaul-road-filter">
    <div
      v-if="!expanded"
      class="spl-linehaul-road-filter__collapsed">
      <button
        :disabled="searchActive"
        class="spl-linehaul-road-filter__text"
        tabindex="1"
        role="button"
        style="grid-column: 1"
        @click="toggleExpand">
        <p>{{ filterText }}</p>
      </button>
      <button
        :disabled="searchActive"
        tabindex="2"
        class="spl-linehaul-road-filter__icon-button spl-linehaul-road-filter__edit-filter"
        style="grid-column: 2"
        @click="toggleExpand">
        <img src="../../../assets/icon-edit.svg">
      </button>
      <button
        :disabled="searchActive"
        tabindex="3"
        class="spl-linehaul-road-filter__icon-button spl-linehaul-road-filter__refresh"
        style="grid-column: 3"
        @click="handleReload">
        <img src="../../../assets/icon-restore.svg">
      </button>
    </div>
    <div v-else>
      <div class="spl-linehaul-road-filter__date">
        <div class="spl-linehaul-road-filter__date--from">
          <form-label>From Date</form-label>
          <form-datepicker v-model="fromDate" />
        </div>
        <div class="spl-linehaul-road-filter__date--to">
          <form-label>To Date</form-label>
          <form-datepicker v-model="toDate" />
        </div>
      </div>
      <div class="spl-linehaul-road-filter__buttons">
        <form-button class="spl-linehaul-road-filter__apply" @onClick="finishEditing">
          Apply
        </form-button>
        <form-button class="spl-linehaul-road-filter__clear" @onClick="clearFilter">
          Clear
        </form-button>
        <form-button
          :secondary="true"
          class="spl-linehaul-road-filter__cancel"
          @onClick="handleCancel">
          Cancel
        </form-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import Helpers from '@/helpers.vue'
import { cloneDeep } from 'lodash'

export default {
  mixins: [Helpers],
  data () {
    return {
      dateFormat: 'dd.MM.yyyy',
      fromDate: moment().toISOString(true),
      toDate: moment().toISOString(true),
      localFilter: {
        fromDate: moment().toISOString(true),
        toDate: moment().toISOString(true)
      },
      expanded: true
    }
  },
  computed: {
    ...mapGetters('linehaulRoad', ['linehaulRoadList']),
    ...mapGetters('provider', ['activeProviderOptions']),
    ...mapState('linehaulRoad', ['linehaulRoadFilter']),
    filterText () {
      var text:string = 'Filter - '
      text += 'Date: ' + moment(this.fromDate).format('YYYY-MM-DD') + ' - ' + moment(this.toDate).format('YYYY-MM-DD')
      return text
    },
    searchActive () {
      return this.$route.query.search !== undefined
    }
  },
  watch: {
    fromDate: function (newVal) {
      this.localFilter.fromDate = moment(newVal).format()
    },
    toDate: function (newVal) {
      this.localFilter.toDate = moment(newVal).format()
    }
  },
  mounted () {
    if (this.linehaulRoadFilter) {
      this.localFilter = cloneDeep(this.linehaulRoadFilter)
      this.fromDate = moment(this.localFilter.fromDate).format()
      this.toDate = moment(this.localFilter.toDate).format()
    }

    this.loadLinehaulRoadList({
      From_Date: this.localFilter.fromDate,
      To_Date: this.localFilter.toDate
    })
    this.toggleExpand()
  },
  methods: {
    ...mapActions('linehaulRoad', ['setFilter', 'sortList', 'loadLinehaulRoadList', 'loadLinehaulRoadFilter']),
    toggleExpand () {
      this.expanded = !this.expanded
    },
    handleCancel () {
      this.toggleExpand()
    },
    clearFilter () {
      this.localFilter = {
        fromDate: this.formatDate(new Date(), false),
        toDate: this.formatDate(new Date(), false)
      }
      this.onFilterChange()
      this.setCurrentFilter(this.localFilter)
    },
    finishEditing () {
      this.onFilterChange()
      this.toggleExpand()
    },

    onFilterChange () {
      this.loadLinehaulRoadList({
        From_Date: this.localFilter.fromDate,
        To_Date: this.localFilter.toDate
      })
      this.setCurrentFilter(this.localFilter)
      this.sortList({ Customer_ID: 'desc' })
    },
    handleReload () {
      this.$emit('onReload')
    },
    setCurrentFilter (filter) {
      this.loadLinehaulRoadFilter(filter)
    }
  }
}
</script>

<style lang="scss">
@import '../../../variables.scss';

.spl-linehaul-road-edit-action-bar {
    background-color: $yellowButtonLabelHover;
    bottom: 0;
    height: 70px;
    padding: 15px $mainPadding;
    position: fixed;
    display: grid;
    grid-template-columns: 150px auto 150px;
    width: 100%;

    .spl-label {
        color: $darkerYellow;
    }
    .spl-input {
        width: 450px;
    }
    .col3 {
        .spl-button {
            background-color: $footerButtonYellow;
            color: $yellowButtonLabel;
            margin: 0 2px 0 0;
            padding: 0 10px;
        }
    }
    .col2 {
        .spl-button {
            background-color: $mainInputColor;
            color: $footerButtonDarkGreyText;
            float: right;
        }
    }
}
.spl-linehaul-road-filter {
  background-color: $yellowButtonLabelHover;
  position: relative;
  padding: 0 $mainPadding;
  margin-bottom: 15px;
  &--return {
    background: $darkRed;
  }
  &__date {
    display: grid;
    padding: 20px 0;
    width: 100%;
    grid-template-columns: 220px 220px 60px 74px 87px 83px;
    grid-gap: 10px;
    &--from {
      grid-column: 1;
    }
    &--to {
      grid-column: 2;
    }
    &--today {
      grid-column: 3;
    }
    &--last-day {
      grid-column: 4;
    }
    &--last-week {
      grid-column: 5;
    }
    &--last-month {
      grid-column: 6;
    }

    .spl-button {
      margin: 22px 0 0 0;
      padding: 0px;
    }
  }

  &__multiselects {
    display: grid;
    padding: 20px 0;
    width: 100%;
    grid-template-columns: minmax(250px, 2000px)
    minmax(250px, 2000px)
    minmax(250px, 2000px);

    &--country {
      grid-column: 1;
      grid-row: 1;
    }

    &--customer {
      grid-column: 2;
      grid-row: 1;
    }

    &--provider {
      grid-column: 3;
      grid-row: 1;
    }

    grid-gap: 10px;
    .spl-button {
      margin: 22px 7px 0 0;
      padding: 0px 10px;
    }
  }

  &__other {
    display: grid;
    padding: 20px 0;
    width: 100%;
    grid-template-columns: 150px 150px 100px
    minmax(250px, 2000px)
    minmax(250px, 2000px);
    grid-gap: 10px;
    &--postal-from {
      grid-column: 1;
    }
    &--postal-to {
      grid-column: 2;
    }
  }

  &__collapsed {
    display: grid;
    grid-template-columns: auto 50px 50px;
    grid-gap: 10px;
    padding: 10px 0;
    .spl-button {
      margin: 0;
    }
    input {
      margin: 0;
    }
  }

  &__icon-button {
    cursor: pointer;
    background: #111;
    border: 0;
    border-radius: 5px;
    &:focus {
      background-color: #222;
    }
    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }

  &__text {
    width: 100%;
    cursor: pointer;
    background: 0;
    border: 0;
    text-align: left;
    color: white;
    height: 40px;
    font-family: "Open Sans", sans-serif;
    font-weight: 400;
    font-size: 13px;
    p {
      margin: 0;
    }
    &:focus {
      background-color: grey;
    }
    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
  &__flow {
    margin-bottom: 35px;
  }
  &__apply, &__clear, &__default, &__cancel  {
    width: 150px;
    margin-bottom: 20px
  }
}

@media (max-width: 800px) {
  .spl-linehaul-road-filter {
    &__date,  &__mutliselects,  &__other {
      grid-template-columns: 100%;
    }
  }
}

@include mobile() {
  .spl-linehaul-road-filter {
    padding: 3px;

    &__refresh, &__search-input, &__search {
      display: none;
    }
    &__edit {
      margin-right: 5px;
    }
    &__collapsed {
      display: flex;
    }

    &__icon-button {
      width: 40px;
    }
    &__text {
      width: calc(100% - 50px);
    }
    &__date {
      display: inline;
      &--from {
        & .el-input {
          width: 100% !important;
        }
        grid-area: a
      }
      &--to {
        & .el-input {
          width: 100% !important;
        }
        grid-area: b
      }

      & .spl-button {
        margin: 5px;
        height: 35px;
        width: calc(50% - 10px);
        font-size: 14px;
      }
    }

    &__multiselects {
      grid-template-columns: 100%;
      & .spl-multiselect {
        margin-bottom: 5px;
      }
      &--country {
        grid-column: 1;
        grid-row: 1;
      }

      &--customer {
        grid-column: 1;
        grid-row: 2;
      }

      &--linehaul-roadstatus {
        grid-column: 1;
        grid-row: 3;
      }

      &--service-level {
        grid-column: 1;
        grid-row: 4;
      }

      &--current-event {
        grid-column: 1;
        grid-row: 5;
      }
      &--provider {
        grid-column: 1;
        grid-row: 6;
      }
      &--tag {
        grid-column: 1;
        grid-row: 7;
      }
    }
    &__other {
      & .spl-input {
        margin-bottom: 5px;
        height: 40px;
      }
      &--postal-from {
        grid-column: 1;
        grid-row: 1;
      }
      &--postal-to {
        grid-column: 1;
        grid-row: 2;
      }
    }
    &__apply, &__clear, &__default, &__cancel {
      width: auto;
      margin: 0;
      padding: 5px 5px;
    }
    &__buttons {
      display: inline;
      & .spl-button {
        width: calc(50% - 10px);
        margin: 5px;
        height: 39px;
        font-size: 15px;
      }
    }
  }
}

</style>
